import { useMemo } from 'react';
import Modal from '../../../Components/Modal/Modal';
import moment from 'moment';
import styles from './CalendarPage.module.css';
import { FaFlagCheckered, FaSwimmer } from 'react-icons/fa';
import { GoStopwatch } from 'react-icons/go';

const formatRaceDuration = durationSeconds => {
    const minutes = Math.floor(durationSeconds / 60);
    const seconds = (durationSeconds - minutes * 60).toFixed(2).padStart(5, '0');
    return `${minutes}:${seconds.replace('.', ',')}`;
};

export default function ShowRecap({ data, closeCB }) {
    const [duration, volume, stress, races] = useMemo(() => {
        let duration = 0;
        let stress = 0;
        let volume = 0;
        let races = [];
        let totalTests = 0;
        for (const event of data.events) {
            if (event.type === 'workout') {
                volume += event.volume || 0;
                duration +=
                    (event.trainingDurationMin || 0) * 60 + (event.trainingDurationSec || 0);
                stress += event.tss || 0;
            } else if (event.type === 'race') {
                const raceData = {
                    title: event.title || 'Race',
                    date: moment(event.start).format('DD/MM/YYYY'),
                    distance: Number(event.raceType) || 0,
                    style: event.raceStyle || 'Unknown',
                    duration:
                        event.splits && event.splits.length > 0
                            ? event.splits.reduce(
                                  (total, split) => total + (split.duration || 0),
                                  0
                              )
                            : 0
                };
                races.push(raceData);
            } else if (event.type === 'test') {
                totalTests++;
            }
        }

        return [duration, volume, stress, races, totalTests];
    }, [data]);

    const totalWorkouts = data.events.filter(event => event.type === 'workout').length;
    const weekStart = moment(data.start).startOf('week').format('DD/MM/YYYY');
    const weekEnd = moment(data.start).endOf('week').format('DD/MM/YYYY');
    const weekNumber = moment(data.start).week();
    const totalTests = data.events.filter(event => event.type === 'test').length;

    return (
        <Modal
            closeCB={closeCB}
            title={`Weekly Recap (Week ${weekNumber}: ${weekStart} - ${weekEnd})`}
        >
            <div className={styles.recapWrap}>
                <div className={styles.recapDetailsWrap}>
                    <h4 className={styles.recapFlagWorkout}>
                        <FaSwimmer className={styles.recapFlagWorkout} /> Swimming Training Details
                    </h4>
                    <div className={styles.recapDetails}>
                        <div>
                            Workouts: {data.completed} ({data.scheduled})
                        </div>
                        <div>
                            Distance: {volume} (
                            {volume / totalWorkouts ? (volume / totalWorkouts).toFixed(2) : 0})
                        </div>
                        <div>
                            Duration: {duration} (
                            {duration / totalWorkouts ? (duration / totalWorkouts).toFixed(2) : 0})
                        </div>
                        <div>
                            Stress: {stress.toFixed(2)} (
                            {stress / totalWorkouts ? (stress / totalWorkouts).toFixed(2) : 0})
                        </div>
                    </div>
                </div>

                <div className={styles.recapDetailsWrap}>
                    <h4 className={styles.recapFlagTest}>
                        {' '}
                        <GoStopwatch /> Swimming Test Details
                    </h4>
                    <div className={styles.recapDetails}>
                        <div>Total Completed: {totalTests}</div>
                    </div>
                </div>

                <div className={styles.recapDetailsWrap}>
                    <h4 className={styles.recapFlagRace}>
                        {' '}
                        <FaFlagCheckered className={styles.recapFlagRace} /> Race Details
                    </h4>
                    <div className={styles.recapDetails}>
                        {races.length === 0 ? (
                            <div>No races this week</div>
                        ) : (
                            races.map((race, index) => (
                                <div
                                    key={index}
                                    style={{
                                        marginBottom: '10px',
                                        padding: '8px',
                                        border: '1px solid #ddd',
                                        borderRadius: '4px'
                                    }}
                                >
                                    <div>
                                        <strong>{race.title}</strong> ({race.date})
                                    </div>
                                    <div>Distance: {race.distance}m</div>
                                    <div>Style: {race.style}</div>
                                    <div>Duration: {formatRaceDuration(race.duration)}</div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    );
}
